import * as React from 'react';
import { Container, Row, Col } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { stat } from 'fs';
import 'react-notifications-component/dist/theme.css';
import BibleList from "./bibleList";
import BibleDetail from "./bibleDetail";
import { Capitalize, showAlert } from '../common/functions';

class BiblePageComponent extends React.Component {
	state = {
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: -1,
		title: "",
		langcode: ""
	}
	constructor(props: any) {
		super(props);
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);

		this.state = {
			isView: false,
			selectedId: false,
			dropdownShopOpen: false,
			page: tValue,
			id: id,
			title: "",
			langcode: ""
		}
		this.handleCallBackMethod = this.handleCallBackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search)).get("page");
		let tValue = tokenstr === null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr === null ? -1 : parseInt(idstr);
		var pageValue = id === -1 ? tValue : "detail";
		var langCode = localStorage.getItem("langCode");
		var langcodeValue = langCode === null ? "" : JSON.parse(langCode);

		this.setState({
			...stat,
			page: pageValue,
			id: id,
			isView: pageValue === "" ? true : false,
			langcode: langcodeValue
		});
		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem('alertMessage', "");
		}
		document.title = `${pageValue==="" ? "Bibles" : "Bible"} - Daily Audio Bible Administration`;
	}

	handleCallBackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		return (
			<Container>
				<Row>
					<Col lg="12">
						{this.state.page === "add" && (
							<div>
								<h2>
									<FontAwesomeIcon icon={faBook} />
									<span data-testid="biblePageTitle"> Bibles - Create New</span>
								</h2>
								<hr />
								<BibleDetail callback={this.handleCallBackMethod} id={this.state.id}  />
							</div>
						)}
						{this.state.page === "detail" && (
							<div>
								<h2>
									<FontAwesomeIcon icon={faBook} />
									<span data-testid="biblePageTitle"> Bibles - {Capitalize(title)} Details</span>
								</h2>
								<hr />
								<BibleDetail callback={this.handleCallBackMethod} id={this.state.id} />
							</div>
						)}
						{this.state.page === "" && this.state.isView && (<div>
							<h2>
								<FontAwesomeIcon icon={faBook} />
								<span data-testid="biblePageTitle"> Bibles</span>
							</h2>
							<hr />
							<BibleList langcode={this.state.langcode} />
						</div>)}
					</Col>
				</Row>
			</Container>
		);
	}
}

export default BiblePageComponent;